import Marquee from 'react-fast-marquee';

const brands = [
  { name: 'Samsung', logo: 'https://logo.clearbit.com/samsung.com' },
  { name: 'LG', logo: 'https://logo.clearbit.com/lg.com' },
  { name: 'Whirlpool', logo: 'https://logo.clearbit.com/whirlpool.com' },
  { name: 'Bosch', logo: 'https://logo.clearbit.com/bosch.com' },
  { name: 'KitchenAid', logo: 'https://logo.clearbit.com/kitchenaid.com' },
  { name: 'Maytag', logo: 'https://logo.clearbit.com/maytag.com' },
  { name: 'Frigidaire', logo: 'https://logo.clearbit.com/frigidaire.com' },
  { name: 'GE', logo: 'https://logo.clearbit.com/geappliances.com' },
];

export const BrandsSlider = () => {
  return (
    <section className="py-16 bg-[#F8F9FC]" data-testid="brands-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10">
        <h2 
          className="text-2xl md:text-3xl font-bold text-center mb-2"
          style={{ fontFamily: 'Montserrat, sans-serif', color: '#1A2B4C' }}
        >
          Brands We Repair
        </h2>
        <p className="text-center text-[#475569]">
          Expert service for all major appliance brands
        </p>
      </div>
      
      <div className="relative marquee-gradient">
        <Marquee speed={40} gradient={false} pauseOnHover>
          {brands.concat(brands).map((brand, index) => (
            <div 
              key={`${brand.name}-${index}`}
              className="mx-8 md:mx-12 flex items-center justify-center"
              data-testid={`brand-${brand.name.toLowerCase()}`}
            >
              <img
                src={brand.logo}
                alt={`${brand.name} appliance repair`}
                className="brand-logo h-12 md:h-16 w-auto object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `<span class="text-xl font-bold text-gray-400">${brand.name}</span>`;
                }}
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default BrandsSlider;
